export class CustomError extends Error {
	public code: string;
	public expected: boolean;

	constructor(message?: string, cause?: unknown, code?: string) {
		const options: ErrorOptions = {
			cause: cause,
		};

		super(message ?? 'Unexpected error', options);

		this.code = code ?? 'ERROR_UNEXPECTED';
	}
}
